/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'app.bsky.graph.listitem'

export { $nsid }

/** Record representing an account's inclusion on a specific list. The AppView will ignore duplicate listitem records. */
type Main = {
  $type: 'app.bsky.graph.listitem'

  /**
   * The account which is included on the list.
   */
  subject: l.DidString

  /**
   * Reference (AT-URI) to the list record (app.bsky.graph.list).
   */
  list: l.AtUriString
  createdAt: l.DatetimeString
}

export type { Main }

/** Record representing an account's inclusion on a specific list. The AppView will ignore duplicate listitem records. */
const main = /*#__PURE__*/ l.record<'tid', Main>(
  'tid',
  $nsid,
  /*#__PURE__*/ l.object({
    subject: /*#__PURE__*/ l.string({ format: 'did' }),
    list: /*#__PURE__*/ l.string({ format: 'at-uri' }),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
  }),
)

export { main }

export const $type = $nsid
export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main)
export const $build = /*#__PURE__*/ main.build.bind(main)
export const $assert = /*#__PURE__*/ main.assert.bind(main)
export const $check = /*#__PURE__*/ main.check.bind(main)
export const $cast = /*#__PURE__*/ main.cast.bind(main)
export const $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main)
export const $matches = /*#__PURE__*/ main.matches.bind(main)
export const $parse = /*#__PURE__*/ main.parse.bind(main)
export const $safeParse = /*#__PURE__*/ main.safeParse.bind(main)
export const $validate = /*#__PURE__*/ main.validate.bind(main)
export const $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main)
